import { Controller } from "@hotwired/stimulus";

// Ticks a "time until departure" line on the public ticket page
// (app/views/flight_tickets/show.html.erb) once a second - see
// FlightTicketsHelper for the day-part Bengali time this pairs with.
// Pure client-side countdown against a target timestamp rendered by the
// server; no polling, no server round-trip.
const BENGALI_DIGITS = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

function bengaliDigits(number) {
  return String(number)
    .split("")
    .map((char) => (/\d/.test(char) ? BENGALI_DIGITS[Number(char)] : char))
    .join("");
}

export default class extends Controller {
  static targets = ["output"];
  static values = { target: String };

  connect() {
    this._deadline = new Date(this.targetValue).getTime();
    this._tick();
    this._timer = setInterval(this._tick.bind(this), 1000);
  }

  disconnect() {
    clearInterval(this._timer);
  }

  _tick() {
    const remaining = this._deadline - Date.now();

    if (remaining <= 0) {
      clearInterval(this._timer);
      this.outputTarget.textContent = "ফ্লাইট ছেড়ে গেছে";

      // The server only picked one target segment at render time - reload
      // so it can pick again now that this one has departed. On a
      // connection that lands on the next leg's departure instead of
      // sitting on "departed" while there's still a flight to catch; on a
      // single-leg booking the countdown box just disappears (see
      // flight_tickets/show.html.erb).
      window.location.reload();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days > 0) parts.push(`${bengaliDigits(days)} দিন`);
    parts.push(`${bengaliDigits(hours)} ঘণ্টা`);
    parts.push(`${bengaliDigits(minutes)} মিনিট`);
    parts.push(`${bengaliDigits(seconds)} সেকেন্ড`);

    this.outputTarget.textContent = parts.join(" ");
  }
}
